import { Box } from "@mui/material";
import { FC, PropsWithChildren } from "react";

interface Props {
  top?: any;
}

const MainWrapper: FC<PropsWithChildren<Props>> = ({ children, top }) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: top ?? { xs: "8rem", lg: "10rem", xl: "15rem" },
        right: { xs: "3rem", lg: "20rem", xl: "30rem" },
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        width: { lg: "900px", xl: "1100px" },
      }}
    >
      {children}
    </Box>
  );
};

export default MainWrapper;
